var map = {
	"./arrow.svg": "b6e4",
	"./check.svg": "f75a",
	"./close.svg": "7710",
	"./collection.svg": "6c06",
	"./comment.svg": "03ee",
	"./edit.svg": "aa46",
	"./good.svg": "9765",
	"./hot.svg": "443a",
	"./like-hover.svg": "0730",
	"./like.svg": "c814",
	"./live.svg": "a8d9",
	"./living.svg": "f71d",
	"./notice.svg": "fc99",
	"./play.svg": "fb4f",
	"./sex.svg": "e200",
	"./time.svg": "3add",
	"./triangle.svg": "f13f",
	"./watch.svg": "e66d",
	"./withdrawal.svg": "39b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";